import { Router } from '@angular/router';
import { LanguageService } from './../Services/languageService';
import { Component } from '@angular/core';
import { LocationStrategy } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { NgIdleKeepaliveModule, Keepalive } from '@ng-idle/keepalive';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { DialogService } from "ng2-bootstrap-modal";
import { ConfirmComponent } from '../Pages/ConfirmComponet/confirm.component';

declare let $: any;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  // styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  lng = "Arabic";

  idleState = 'Not started.';
  timedOut = false;

  constructor(private lngService: LanguageService, private location: LocationStrategy, public translate: TranslateService, private idle: Idle, private keepalive: Keepalive, private dialogService: DialogService, private router: Router) {

    idle.setIdle(600);
    idle.setTimeout(300);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      this.dialogService.removeAll();
    });



    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;

      if (this.router.url != "/BeforeLogin/Login" && this.router.url != "/BeforeLogin/NewReg") {

        this.dialogService.removeAll();
        sessionStorage.clear();
        this.router.navigate(["/BeforeLogin/Login"]);
      }
      this.reset();
    });

    idle.onIdleStart.subscribe(() => {
      this.idleState = 'You\'ve gone idle!';
      if (this.router.url != "/BeforeLogin/Login" && this.router.url != "/BeforeLogin/NewReg") {
        this.showConfirm();
      }
    });

    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'Your application logout automaticall after  ' + countdown + ' seconds!Press Cancel to continue Session other wise press OK';
      this.lngService.setNgIdleMsg(this.idleState);
    });
    this.reset();


    sessionStorage.setItem("BackClicked", "N");
    translate.addLangs(['en', 'ar']);
    translate.setDefaultLang('ar');
    // this.translate.use('en');


    this.location.onPopState(() => {
      sessionStorage.setItem("BackClicked", "Y");
      return false;
    });

  }
  
  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }
  setLang() {
    $(".row").toggleClass("New")
    let ln = "en";
    if (this.lng == "Arabic") {
      ln = "ar";
      this.lng = "English";
      $("body").addClass("abc");

    }
    else {
      ln = "en";
      this.lng = "Arabic";
      $("body").removeClass("abc");
    }

    this.lngService.setLanguage(ln);
    this.lngService.setLng(ln);

  }
  SelectType() {

  }

  showConfirm() {
    let disposable = this.dialogService.addDialog(ConfirmComponent, {
      title: 'SESSION TIMEOUT!',
      message: this.idleState
    })
      .subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.idle.clearInterrupts();
        }
        else {
          this.reset();
        }
      });

    setTimeout(() => {
      disposable.unsubscribe();
    }, 10000);
  }
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/app/app.component.ts